import { showBackdrop, hideBackdrop } from '../components/backdrop';
import { atQuery } from '../components/mediaQueries';

$(function () {
  const $langSwitcher = $('.lang-switcher');
  if ($langSwitcher.length <= 0) return;

  const $langSwitcherModal = $('.lang-switcher__modal');
  if ($langSwitcherModal.length <= 0) return;

  const $langSwitcherModalClose = $('.lang-switcher__modal__close');

  $langSwitcher.on('click', function () {
    $($langSwitcherModal).addClass('open');

    atQuery('min', 'md', () => {
      showBackdrop();
      $('#shopify-section-footer').css({'z-index': 'unset'});
    });

    atQuery('max', 'md', () => {
      $('#shopify-section-footer').css({'z-index': '13'});
    });
  });

  $($langSwitcherModalClose).on('click', function() {
    $($langSwitcherModal).removeClass('open');
    $('#shopify-section-footer').css('z-index', '');

    atQuery('min', 'md', () => {
      hideBackdrop();
    });
  });
});
